<mat-card class="cardGroup">
    <div class="flexBeetwen">
        <p class="headline6"> {{'settings.groups.newCard.title' | translate}} </p>
        <div *ngIf="!isMobile">
            <button mat-stroked-button color="primary" class="primaryButton2" (click)="toggleNew()" > {{'settings.groups.newCard.cancel' | translate | uppercase}} </button>
            <button mat-raised-button color="primary" class="primaryButton2" (click)="onSubmit()" [disabled]="disableSubmit || !groupForm.valid"> {{'settings.groups.newCard.confirm' | translate}} </button>
        </div>
    </div>

    <p class="subtitle3"> {{'settings.groups.newCard.subtitle' | translate}}  </p>

    <div class="flexLeft">
        <div *ngFor="let day of days">
            <button *ngIf="!day.selected" 
                class="marginRigth"
                [disabled]="day.disabled" 
                (click)="saveDay(day)"
                mat-stroked-button>
                <span *ngIf="!isMobile">
                    {{day.name}}
                </span>
                <span *ngIf="isMobile">
                    {{day.name.charAt(0)}}
                </span>
            </button>
            <button *ngIf="day.selected && !day.disabled" 
                class="selectedOption marginRigth" 
                (click)="saveDay(day)"
                mat-raised-button>
                <span *ngIf="!isMobile">
                    {{day.name}}
                </span>
                <span *ngIf="isMobile">
                    {{day.name.charAt(0)}}
                </span>
            </button>
        </div>
    </div>

    <p class="subtitle3"> {{'settings.groups.newCard.hour' | translate}}  </p>
    <form [formGroup]="groupForm">
        <mat-form-field appearance="fill" class="inputFormLine">
            <mat-label>{{ 'settings.groups.newCard.hourInput' | translate}}</mat-label>
            <input 
                required 
                id="hourInput" 
                formControlName="hora" 
                type="text"  
                [mask]="timeMask"
                placeholder="hh:mm"
                matInput>
        </mat-form-field>

        <!-- <mat-form-field appearance="fill" class="inputFormLine">
            <mat-label>{{ 'settings.groups.newCard.amount' | translate}}</mat-label>
            <input required id="amountInput" formControlName="capacidad" type="number" min="1"
            matInput>
        </mat-form-field> -->

        <div *ngIf="isMobile">
            <button mat-stroked-button color="primary" class="primaryButton2" (click)="toggleNew()" > {{'settings.groups.newCard.cancel' | translate | uppercase}} </button>
            <button mat-raised-button color="primary" class="primaryButton2" (click)="onSubmit()" [disabled]="disableSubmit || !groupForm.valid"> {{'settings.groups.newCard.confirm' | translate}} </button>
        </div>
    </form>
</mat-card>
